<template>
  <el-dialog title="设备详情" :visible.sync="visible" width="1200px" :close-on-click-modal="false" @close="handleClose" top="5vh">
    <el-form ref="deviceForm" :model="deviceData" label-width="140px" size="small" v-loading="loading">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="注册代码">
            <el-input v-model="deviceData.eqpRegCod" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备代码">
            <el-input v-model="deviceData.eqpStationCod" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="产品编号">
            <el-input v-model="deviceData.factoryCod" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="内部编号">
            <el-input v-model="deviceData.eqpInnerCod" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="使用登记证号">
            <el-input v-model="deviceData.eqpUsecertCod" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用单位">
            <el-input v-model="deviceData.useUntName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="使用地点">
            <el-input v-model="deviceData.eqpUseAddr" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="制造单位">
            <el-input v-model="deviceData.makeUntName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="改造单位">
            <el-input v-model="deviceData.renovationUntName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="维保单位">
            <el-input v-model="deviceData.serviceUntName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="维保负责人">
            <el-input v-model="deviceData.maintainAdmin" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备类别">
            <el-input v-model="deviceData.eqpSortName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备品种">
            <el-input v-model="deviceData.eqpVartName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备名称">
            <el-input v-model="deviceData.eqpName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="设备型号">
            <el-input v-model="deviceData.eqpMod" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所在区域">
            <el-input v-model="deviceData.eqpAreaName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="统一信用代码">
            <el-input v-model="deviceData.unifiedCreditCode" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小区/建筑名称">
            <el-input v-model="deviceData.houseName" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="制造日期">
            <el-input v-model="deviceData.makeDate" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="改造日期">
            <el-input v-model="deviceData.renovationDate" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="救援电话">
            <el-input v-model="deviceData.mantPhone" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话">
            <el-input v-model="deviceData.usePhone" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 1. 其他基础信息（与小程序对齐） -->
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="安全管理员">
            <el-input v-model="deviceData.safeMen" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="安全管理员联系电话">
            <el-input v-model="deviceData.safeMenPhone" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="检验费标准">
            <el-input v-model="deviceData.inspectFee" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="基准年月">
            <el-input :value="formatFirstYear(deviceData.testCharge)" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="监管标识">
            <el-input v-model="deviceData.OIDNO" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 2. 电梯技术参数信息 -->
      <el-divider>电梯技术参数信息</el-divider>

      <!-- 乘客电梯、曳引式客梯、曳引式货梯 显示的字段 -->
      <div v-if="deviceData.eqpName === '乘客电梯' || deviceData.eqpName === '曳引式客梯' || deviceData.eqpName === '曳引式货梯'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="层/站/门">
              <el-input v-model="deviceData.elefloornumber" readonly style="width: 80px;" /> /
              <el-input v-model="deviceData.elestadenumber" readonly style="width: 80px; margin: 0 4px;" /> /
              <el-input v-model="deviceData.eledoornumber" readonly style="width: 80px;" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="额定载荷(kg)">
              <el-input v-model="deviceData.ratedload" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="额定速度(m/s)">
              <el-input v-model="deviceData.runvelocity" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="控制方式">
              <el-input v-model="deviceData.controlType" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="悬挂装置根数">
              <el-input v-model="deviceData.dragNum" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 自动扶梯、自动人行道 显示的字段 -->
      <div v-if="deviceData.eqpName === '自动扶梯' || deviceData.eqpName === '自动人行道'">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名义速度(m/s)">
              <el-input v-model="deviceData.runvelocity" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="倾斜角(°)">
              <el-input v-model="deviceData.dipAngle" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名义宽度(mm)">
              <el-input v-model="deviceData.nomiWidth" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="输送能力">
              <el-input v-model="deviceData.ratedload" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="使用区段长度(m)">
              <el-input v-model="deviceData.slidwayUseLeng" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提升高度(m)">
              <el-input v-model="deviceData.eleheight" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 3. 其他相关信息 -->
      <el-divider>其他相关信息</el-divider>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="登记机关">
            <el-input v-model="deviceData.registerOrg" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="安装单位">
            <el-input v-model="deviceData.installUnit" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="使用单位地址">
            <el-input v-model="deviceData.eqpUseAddr" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用单位管理部门">
            <el-input v-model="deviceData.useUnitDept" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="最近定检单位">
            <el-input v-model="deviceData.ispuntName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最近定检日期">
            <el-input v-model="deviceData.lastIspDate2Fmt" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="最近检测单位">
            <el-input v-model="deviceData.chkUntId" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最近检测日期">
            <el-input v-model="deviceData.lastChkDateFmt" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="最近监检单位">
            <el-input v-model="deviceData.lastMonUnit" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最近安改监检日期">
            <el-input v-model="deviceData.lastMonDate" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="下次定检日期">
            <el-input v-model="deviceData.nextRegularDate" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="下次检测年月">
            <el-input v-model="deviceData.nextTestYearMonth" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="重新启用定检日期">
            <el-input v-model="deviceData.reEnableExamDate" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="制造标准">
            <el-input v-model="deviceData.standardData" readonly />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="最近一次制动试验时间">
            <el-input v-model="deviceData.LAST_BRAKE_TASK_DATE" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="下次制动试验时间">
            <el-input v-model="deviceData.NEXT_BRAKE_TASK_DATE" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDeviceDetail } from '@/api/contract/contract.js'

export default {
  name: 'DeviceDetailDialog',
  data () {
    return {
      visible: false,
      loading: false,
      deviceData: {
        eqpRegCod: '', // 注册代码
        eqpSortName: '', // 设备类别
        eqpStationCod: '', // 设备代码
        eqpVartName: '', // 设备品种
        factoryCod: '', // 产品编号
        eqpName: '', // 设备名称
        eqpInnerCod: '', // 单位内部编号
        eqpMod: '', // 设备型号
        eqpUsecertCod: '', // 使用登记证号
        eqpAreaName: '', // 所在区域
        useUntName: '', // 使用单位
        unifiedCreditCode: '', // 统一信用代码
        eqpUseAddr: '', // 使用地点
        houseName: '', // 小区/建筑名称
        makeUntName: '', // 制造单位
        makeDate: '', // 制造日期
        renovationUntName: '', // 改造单位
        renovationDate: '', // 改造日期
        serviceUntName: '', // 维保单位
        mantPhone: '', // 维保电话
        maintainAdmin: '', // 维保负责人
        usePhone: '', // 联系人电话

        // 新增字段 - 基础信息
        safeMen: '', // 安全管理员
        safeMenPhone: '', // 安全管理员联系电话
        inspectFee: '', // 检验费标准
        testCharge: '', // 基准年月
        OIDNO: '', // 监管标识

        // 新增字段 - 电梯技术参数信息
        elefloornumber: '', // 层数
        elestadenumber: '', // 站数
        eledoornumber: '', // 门数
        ratedload: '', // 额定载荷/输送能力
        runvelocity: '', // 额定/名义速度
        controlType: '', // 控制方式
        dragNum: '', // 悬挂装置根数
        dipAngle: '', // 倾斜角
        nomiWidth: '', // 名义宽度
        slidwayUseLeng: '', // 使用区段长度
        eleheight: '', // 提升高度

        // 新增字段 - 其他相关信息
        registerOrg: '', // 登记机关
        installUnit: '', // 安装单位
        eqpUseAddr: '', // 使用单位地址
        useUnitDept: '', // 使用单位管理部门
        ispuntName: '', // 最近定检单位
        lastIspDate2Fmt: '', // 最近定检日期
        chkUntId: '', // 最近检测单位
        lastChkDateFmt: '', // 最近检测日期
        lastMonUnit: '', // 最近监检单位
        lastMonDate: '', // 最近安改监检日期
        nextRegularDate: '', // 下次定检日期
        nextTestYearMonth: '', // 下次检测年月
        reEnableExamDate: '', // 重新启用定检日期
        standardData: '', // 制造标准/检测依据
        LAST_BRAKE_TASK_DATE: '', // 最近一次制动试验时间
        NEXT_BRAKE_TASK_DATE: '', // 下次制动试验时间
      }
    }
  },
  methods: {
    formatFirstYear (value) {
      const str = value === null || value === undefined ? '' : String(value).trim()
      if (!str) return ''
      // 接口仅返回年份时，前端补充默认月份1用于展示
      if (/^\d{4}$/.test(str)) return `${str}-1`
      return str
    },

    /**
     * 显示设备详情弹窗
     * @param {String} entrustNum - 委托号
     */
    show (entrustNum) {
      this.visible = true
      this.loading = true
      this.resetData()

      // 调用API获取设备详情（不传isDeviceConfirmation，由后端根据备忘录的equipmentConfirmed字段判断）
      getDeviceDetail(entrustNum).then(res => {
        this.loading = false
        if (res && res.retCode === 'ok' && res.additionalData) {
          const data = res.additionalData
          // 映射字段
          this.deviceData = {
            eqpRegCod: data.eqpRegCod || '',
            eqpSortName: data.eqpSortName || '',
            eqpStationCod: data.eqpStationCod || '',
            eqpVartName: data.eqpVartName || '',
            factoryCod: data.factoryCod || '',
            eqpName: data.eqpName || '',
            eqpInnerCod: data.eqpInnerCod || '',
            eqpMod: data.eqpMod || '',
            eqpUsecertCod: data.eqpUsecertCod || '',
            eqpAreaName: data.eqpAreaName || '',
            useUntName: data.useUntName || '',
            unifiedCreditCode: data.unifiedCreditCode || '',
            eqpUseAddr: data.eqpUseAddr || data.EQP_USE_ADDR || '',
            houseName: data.houseName || '',
            makeUntName: data.makeUntName || '',
            makeDate: data.makeDate || '',
            renovationUntName: data.renovationUntName || '',
            renovationDate: data.renovationDate || '',
            serviceUntName: data.serviceUntName || '',
            mantPhone: data.mantPhone || '',
            maintainAdmin: data.maintainAdmin || '',
            usePhone: data.usePhone || '',

            // 基础信息
            safeMen: data.safeMen || '',
            safeMenPhone: data.safeMenPhone || '',
            inspectFee: data.inspectFee || '',
            testCharge: data.testCharge || '',
            OIDNO: data.OIDNO || data.oidno || '',

            // 电梯技术参数信息
            elefloornumber: data.elefloornumber || data.ELEFLOORNUMBER || '',
            elestadenumber: data.elestadenumber || data.ELESTADENUMBER || '',
            eledoornumber: data.eledoornumber || data.ELEDOORNUMBER || '',
            ratedload: data.ratedload || data.RATEDLOAD || '',
            runvelocity: data.runvelocity || data.RUNVELOCITY || '',
            controlType: data.controlType || data.CONTROL_TYPE || '',
            dragNum: data.dragNum || data.DRAGNUM || '',
            dipAngle: data.dipAngle || data.DIPANGLE || '',
            nomiWidth: data.nomiWidth || data.NOMIWIDTH || '',
            slidwayUseLeng: data.slidwayUseLeng || data.SLIDWAYUSELENG || '',
            eleheight: data.eleheight || data.ELEHEIGHT || '',

            // 其他相关信息
            registerOrg: data.registerOrg || '',
            installUnit: data.installUnit || '',
            eqpUseAddr: data.eqpUseAddr || '',
            useUnitDept: data.useUnitDept || '',
            ispuntName: data.ispuntName || '',
            lastIspDate2Fmt: data.lastIspDate2Fmt || data.lastIspDate || '',
            chkUntId: data.chkUntId || '',
            lastChkDateFmt: data.lastChkDateFmt || data.lastChkDate || '',
            lastMonUnit: data.lastMonUnit || '',
            lastMonDate: data.lastMonDate || '',
            nextRegularDate: data.nextRegularDate || '',
            nextTestYearMonth: data.nextTestYearMonth || '',
            reEnableExamDate: data.reEnableExamDate || '',
            standardData: data.standardData || '',
            LAST_BRAKE_TASK_DATE: data.LAST_BRAKE_TASK_DATE || '',
            NEXT_BRAKE_TASK_DATE: data.NEXT_BRAKE_TASK_DATE || '',
          }
        } else {
          this.$message.error(res.retMsg || '获取设备详情失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err.message || '获取设备详情失败')
      })
    },

    /**
     * 重置数据
     */
    resetData () {
      this.deviceData = {
        eqpRegCod: '',
        eqpSortName: '',
        eqpStationCod: '',
        eqpVartName: '',
        factoryCod: '',
        eqpName: '',
        eqpInnerCod: '',
        eqpMod: '',
        eqpUsecertCod: '',
        eqpAreaName: '',
        useUntName: '',
        unifiedCreditCode: '',
        eqpUseAddr: '',
        houseName: '',
        makeUntName: '',
        makeDate: '',
        renovationUntName: '',
        renovationDate: '',
        serviceUntName: '',
        mantPhone: '',
        maintainAdmin: '',
        usePhone: '',

        // 新增字段 - 基础信息
        safeMen: '',
        safeMenPhone: '',
        inspectFee: '',
        testCharge: '',
        OIDNO: '',

        // 新增字段 - 电梯技术参数信息
        elefloornumber: '',
        elestadenumber: '',
        eledoornumber: '',
        ratedload: '',
        runvelocity: '',
        controlType: '',
        dragNum: '',
        dipAngle: '',
        nomiWidth: '',
        slidwayUseLeng: '',
        eleheight: '',

        // 新增字段 - 其他相关信息
        registerOrg: '',
        installUnit: '',
        eqpUseAddr: '',
        useUnitDept: '',
        ispuntName: '',
        lastIspDate2Fmt: '',
        chkUntId: '',
        lastChkDateFmt: '',
        lastMonUnit: '',
        lastMonDate: '',
        nextRegularDate: '',
        nextTestYearMonth: '',
        reEnableExamDate: '',
        standardData: '',
        LAST_BRAKE_TASK_DATE: '',
        NEXT_BRAKE_TASK_DATE: '',
      }
    },

    /**
     * 关闭弹窗
     */
    handleClose () {
      this.visible = false
      this.resetData()
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>
